import { EsignDisclosure } from 'signer-app/context/signer-app-client/signer-api';

export function createDownloadUrl(
  esignDisclosure: EsignDisclosure,
  transmissionGuid: string,
  locales: string[] = ['en-US'],
) {
  const searchParams = new URLSearchParams();

  searchParams.set('tsm_guid', transmissionGuid);
  searchParams.set('esign_disclosure_id', String(esignDisclosure.id));
  searchParams.set('user_culture', locales[0].replace('-', '_'));

  return `/home/getDisclosure?${searchParams.toString()}`;
}
